








import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AnalysisDetails',
  props: {
    title: {
      type: String
    },
    color: {
      type: String
    },
    tags: {
      type: Array
    }
  }
})
